export const GaEvents = {
  page_land: 'fe_estresult_land',
  book_now_cta_tap: 'fe_estresult_cta_confirm_tap',
} as const;

export const MoeEvents = {
  book_now_cta_tap: 'fe_estresult_cta_confirm_tap_moe',
} as const;

export const DEFAULT_TRUCK_ICON = {
  path: 'https://nest-platform-assets.porter.in/default_truck_icon_v2_dfe20c523f/default_truck_icon_v2_dfe20c523f.svg',
  altText: `Default Vehicle Icon v2`,
} as const;

export const OffersText = {
  'en-IN': 'Get up to 30% off on your first order. *T&C apply',
  'default': 'Get additional discount in the next step',
} as const;

export const OffersIcon = {
  path: 'https://nest-platform-assets.porter.in/offers_6774a8617a/offers_6774a8617a.svg',
  altText: `Offers Icon`,
} as const;

export const DownloadAppQrVm = {
  title: 'Love what you see? ❤️',
  sub_title: 'Get the best experience on our mobile app',
  qr_text: 'Scan QR code to download the app',
  qr: {
    url: 'https://nest-platform-assets.porter.in/download_qr_code_790dca4b34/download_qr_code_790dca4b34.png',
    altText: 'Download Porter App QR Code',
  },
} as const;

export const DownloadAppQrVmIntl = {
  title: 'Love what you see? ❤️',
  sub_title: 'Get the best experience on our mobile app',
  qr_text: 'Scan QR code to download the app',
  qr: {
    url: 'https://nest-platform-assets.porter.in/qr_code_6ac327e0fa/qr_code_6ac327e0fa.png',
    altText: 'Download Porter App QR Code',
  },
} as const;
